export default {
  name: null,
  roles: [],
  fisPersid: null,
  email: null,
  forscher: null,
  token: null,
  orgas: null,
  activeOrga: 0,
  selectedOrgaID: null,
  loading: false,
  savedViews: [],
  activeViewState: 0,
  activeViewStates: [
    {
      id: 'internal',
      label: 'menu.list.public.internal',
      desc: 'menu.list.public.internal.desc',
      route: {
        name: 'start'
      }
    },
    {
      id: 'external',
      label: 'menu.list.public.external',
      desc: 'menu.list.public.external.desc',
      route: {
        name: 'public',
        params: {
          type: 'ou',
          id: 1,
          resourceType: 'forschungsprojekt'
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/user/state.js